/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownParentQualification } from '../models/db_DropdownParentQualification';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ParentQualifications {
    /**
     * Get a list of parent qualifications
     * @returns db_DropdownParentQualification OK
     * @throws ApiError
     */
    public static listParentQualifications(): CancelablePromise<Array<db_DropdownParentQualification>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/parent-qualifications',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
